export default __webpack_public_path__ + "static/media/icon_endtype_Eternity.d7c96c4c.png";